/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserProfileResponse } from '../models/UserProfileResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileUserService {
    /**
     * Get current mobile user profile
     * Get user profile for display in mobile app UI (includes personal contact info)
     * @param xMobileAuth
     * @returns UserProfileResponse Successful Response
     * @throws ApiError
     */
    public static getMobileUserProfileV1(
        xMobileAuth?: (string | null),
    ): CancelablePromise<UserProfileResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mobile/v1/user/me',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
